import React, { useState } from "react";
import FileUploadUI from "../../../ui/FileUploadUI";
import { postNoteDocument } from "../../../../services/httpClient";
import { useParams } from "react-router-dom";
import { Note } from "../../../../types/note";
import ToastMsg from "../../../ui/ToastMsg";

interface FileUploadState {
  header: string;
  documents: any;
  setDocuments: any;
  note: Note | undefined;
  editNote: boolean;
  getDocuments: any;
  setErrorMessage?: any;
  setIsLoading: any;
}

const FileUploadNotes = ({
  header,
  documents,
  setDocuments,
  note,
  editNote = false,
  getDocuments,
  setErrorMessage,
  setIsLoading,
}: FileUploadState) => {
  const { id } = useParams();
  const [selectedFile, setSelectedFile]: any = useState();
  const [uploadIsEnabled, setUploadIsEnabled] = useState<boolean>(false);
  const [showToast, setShowToast] = useState<boolean>(false);
  const [toastBody, setToastBody] = useState<string>("");
  const [toastText, setToastText] = useState<string>("");

  async function uploadFileData(data: any) {
    setIsLoading(true);
    var document;
    if (documents.some((doc: { name: any }) => doc.name === selectedFile.file.name)) {
      setErrorMessage("Cannot upload multiple files with the same name.");
      setIsLoading(false);
      return;
    } else {
      document = {
        name: selectedFile.file.name,
        data: data,
      };
    }

    setDocuments([...documents, document]);

    setSelectedFile("");
    setErrorMessage("");
    setUploadIsEnabled(false);
    if (editNote) {
      postNoteDocument(selectedFile.file.name, data, id, note?.id)
        .then((res: any) => {
          getDocuments();
          // if (getDocuments) {
          //   getDocuments();
          // } else {
          //   const document = {
          //     id: res[0].data.note_document_id,
          //     name: selectedFile.file.name,
          //     data: data,
          //   };
          //   setDocuments([...documents, document]);
          // }
          setIsLoading(false);
          setShowToast(true);
          setToastText("Note Document Uploaded");
          setToastBody(selectedFile.file.name);
        })
        .catch((err: any) => {
          console.log(err);
          setErrorMessage(err?.response?.data?.msg);
        });
    } else {
      setIsLoading(false);
    }
  }

  return (
    <>
      <ToastMsg showToast={showToast} setShowToast={setShowToast} toastText={toastText} toastBody={toastBody} />
      <FileUploadUI
        header={header}
        selectedFile={selectedFile}
        setSelectedFile={setSelectedFile}
        uploadIsEnabled={uploadIsEnabled}
        setUploadIsEnabled={setUploadIsEnabled}
        uploadFileData={uploadFileData}
      />
    </>
  );
};

export default FileUploadNotes;
